export default __webpack_public_path__ + "static/media/14.0d4b19f5.png";